import React, { createContext, useContext, useState } from 'react';

const EmailContext = createContext();

export function EmailProvider({ children }) {
  const [passwordChangeEmail, setPasswordChangeEmail] = useState('');

  return (
    <EmailContext.Provider value={{ passwordChangeEmail, setPasswordChangeEmail }}>
      {children}
    </EmailContext.Provider>
  );
}

export function useEmailContext() {
  return useContext(EmailContext);
}